import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "../Reveal";
import { ArrowLeft, ArrowRight } from "lucide-react";

const quotes = [
  {
    text: "Jennie-Marie gave me back my energy and my confidence. The MNE approach felt gentle yet completely transformed how I eat, move and think.",
    name: "Sarah H.",
    role: "Age 52 · Menopause coaching",
  },
  {
    text: "I'd tried every diet going. For the first time this actually fits my life — and my skin has never looked better since starting Temple Spa.",
    name: "Louise M.",
    role: "Age 47 · Nutrition & skincare",
  },
  {
    text: "Strength training with Jennie-Marie has been life-changing for my joints and my mood. She truly understands women over 40.",
    name: "Deborah K.",
    role: "Age 58 · Personal training",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const go = (d) => setI((p) => (p + d + quotes.length) % quotes.length);
  const q = quotes[i];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-36 bg-linen border-y border-border overflow-hidden">
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-mne-pink/25 blur-[130px]" />
      <div className="relative max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <span className="text-[11px] uppercase tracking-[0.3em] text-gold">Kind Words</span>
        </Reveal>

        <div className="mt-10 min-h-[280px] md:min-h-[240px] flex flex-col items-center justify-center">
          <span className="font-serif text-8xl text-plum/20 leading-none select-none">“</span>
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              data-testid="testimonial-quote"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="-mt-6"
            >
              <p className="font-serif font-light italic text-3xl md:text-4xl leading-snug text-plum max-w-3xl mx-auto">
                {q.text}
              </p>
              <footer className="mt-8">
                <p className="text-[13px] uppercase tracking-[0.2em] text-plum">{q.name}</p>
                <p className="mt-1 text-[12px] tracking-[0.1em] text-stone">{q.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-4">
          <button
            data-testid="testimonial-prev"
            onClick={() => go(-1)}
            className="flex h-12 w-12 items-center justify-center rounded-full border border-plum/30 text-plum transition-colors duration-300 hover:bg-plum hover:text-cream"
            aria-label="Previous testimonial"
          >
            <ArrowLeft size={18} />
          </button>
          <div className="flex gap-2">
            {quotes.map((_, idx) => (
              <button
                key={idx}
                data-testid={`testimonial-dot-${idx}`}
                onClick={() => setI(idx)}
                className={`h-1.5 rounded-full transition-all duration-300 ${idx === i ? "w-8 bg-plum" : "w-1.5 bg-plum/30"}`}
                aria-label={`Go to testimonial ${idx + 1}`}
              />
            ))}
          </div>
          <button
            data-testid="testimonial-next"
            onClick={() => go(1)}
            className="flex h-12 w-12 items-center justify-center rounded-full border border-plum/30 text-plum transition-colors duration-300 hover:bg-plum hover:text-cream"
            aria-label="Next testimonial"
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
